import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import ServiceCard from '../../components/ServiceCard';
import { allServices } from '../../data/services';
import { Helmet } from 'react-helmet';

const CAPEXPage = () => {
  return (
    <div style={{ padding: '4rem 0' }}>
      <Helmet>
        <title>CapEx | Solaric</title>
      </Helmet>
      <Breadcrumb current='CAPEX Model' previous='solutions' />
      <div className='row  justify-content-center'>
        <div className='col-md-6 my-5'>
          <ServiceCard key={allServices[0].id} count={allServices[0] + 1} service={allServices[0]} />
        </div>
      </div>
    </div>
  );
};

export default CAPEXPage;
